module.exports = __webpack_public_path__ + "img/twitch.e04729ff.svg";